const WHO_CARDS = [
  {
    icon: "/business/in1.svg",
    title: "Company all-hands",
    description: "Teams navigating AI adoption and transformation.",
  },
  {
    icon: "/business/in2.svg",
    title: "Tech & AI conferences",
    description: "Builders and engineers shipping with AI.",
  },
  {
    icon: "/business/in3.svg",
    title: "Leadership offsites",
    description: "Executives setting AI strategy and direction.",
  },
  {
    icon: "/business/in4.svg",
    title: "Marketing & media events",
    description: "Content and growth teams exploring AI tools.",
  },
  {
    icon: "/business/in5.svg",
    title: "Founder & startup events",
    description: "Early-stage teams finding AI leverage.",
  },
  {
    icon: "/business/in6.svg",
    title: "Podcasts & conversations",
    description: "Long-form discussions on AI and building.",
  },
] as const;

export default function WhoThisIsFor() {
  return (
    <section className="w-full bg-black py-8 md:py-14 font-fira text-white sm:py-20">
      <div className="mx-auto w-[90%] md:w-[80%]">
        <header className="mb-8 md:mb-10">
          <p className="mb-3 text-xs font-normal uppercase tracking-[1.75px] text-white/80 md:text-sm">
            Who this is for
          </p>
          <h2 className="font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:text-[42px]">
            The session works when the room is right.
          </h2>
        </header>
      </div>

      <div className="overflow-x-auto pb-2 [scrollbar-width:thin] [scrollbar-color:rgba(255,255,255,0.2)_transparent]">
        <ul className="flex gap-4 px-[5%] md:gap-5 md:px-[10%]">
          {WHO_CARDS.map((card) => (
            <li
              key={card.title}
              className="flex w-[260px] shrink-0 flex-col rounded-2xl border border-white/10 bg-[#111110] p-5 md:w-[280px] md:p-6"
            >
              <img
                src={card.icon}
                alt=""
                className="h-7 w-7 object-contain md:h-8 md:w-8"
                loading="lazy"
                decoding="async"
              />
              <h3 className="mt-6 text-base font-semibold leading-snug text-white md:mt-8">
                {card.title}
              </h3>
              <p className="mt-2 text-sm font-normal leading-relaxed text-white/60">
                {card.description}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
